"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromEnv = exports.forDeployEnv = exports.getDeployEnv = void 0;
/**
 * @returns the value of the DEPLOY_ENV environment variable, if it is a valid value
 * 	of `"prod"` or `"dev"`
 * @throws if DEPLOY_ENV environment variable is missing, or an invalid value.
 */
const getDeployEnv = (env = process.env) => {
    switch (env.DEPLOY_ENV) {
        case 'prod':
        case 'dev':
            return env.DEPLOY_ENV;
        case undefined:
            throw new Error('Missing DEPLOY_ENV environment variable.');
        default:
            throw new Error(`Expected DEPLOY_ENV environment variable to be "prod" or "dev", got "${env.DEPLOY_ENV}"`);
    }
};
exports.getDeployEnv = getDeployEnv;
/**
 * Pick a value based on the current `DEPLOY_ENV`.
 *
 * @example const domain = forDeployEnv({ dev: 'charterindexdev.com', prod: 'charterindex.com' });
 */
const forDeployEnv = (values, env = process.env) => values[(0, exports.getDeployEnv)(env)];
exports.forDeployEnv = forDeployEnv;
/**
 * Collect required environment variables.
 *
 * @returns a record of environment variables
 * @throws if any of the environment variables are not present.
 *
 * @example const env = fromEnv([ 'THE_API_KEY', 'THE_DOMAIN' ])
 */
const fromEnv = (keys, env = process.env) => {
    const missing = [];
    const result = keys.reduce((out, key) => {
        const value = env[key];
        if (!value) {
            missing.push(key);
        }
        out[key] = value;
        return out;
    }, {});
    if (missing.length) {
        throw new Error('Missing environment variables: ' + missing.map(key => `"${key}"`).join(', '));
    }
    return result;
};
exports.fromEnv = fromEnv;
//# sourceMappingURL=environment.js.map